import styled, { css } from 'styled-components'
import { Divider, Row } from 'antd'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
export const TableTop = styled(Flex)`
  padding: 15px 20px 10px 20px;
  border-top: 1px solid ${COLORS.GREY_T_90};
`
export const FilterFlex = styled(Flex)`
  width: 50%;
`
export const FilterFlexInput = styled(Flex)`
  width: 20%;
`
export const FilterFlexButton = styled(Flex)`
  width: 17%;
  margin-bottom: -30px;
  opacity: 1;
  animation: emerge 1s ease-in-out forwards;
  animation-delay: 15s;
  cursor: pointer;
`
export const FilterText = styled.p`
  margin-bottom: 0;
  margin-left: 10px;
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.BLACK};
`
export const FilterTextWithUnderLine = styled.p`
  margin-bottom: 0;
  margin-left: 10px;
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.BLACK};
  text-decoration: underline;
  color: blue;
  cursor: pointer;
`
export const FilterTextLabel = styled.p`
  margin-bottom: 0;
  margin-left: 10px;
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_60};
`
export const Wrappera = styled.div``
export const FilterHeader = styled.div`
  padding: 1px;
  gap: 0.5rem;
  width: 310px;
  display: flex;
  flex-direction: column;
`

export const Content = styled.div`
  background-color: #ffffff;
  transition: max-height 0.3s ease-in-out;
  max-height: ${props => (props.isOpen ? '500px' : '0')};
  overflow: auto;
  ${props =>
    props.isOpen &&
    css`
      transition-delay: 0s;
    `}

  & {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.4) transparent;
  }

  &::-webkit-scrollbar {
    width: 3px;
    height: 0.7rem;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #0000001f;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #0000001f;
  }

  &::-webkit-scrollbar-button {
    display: none;
  }

  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`
export const Contents = styled.div`
  padding: 10px;
`
export const Footer = styled.div`
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  float: right;
  cursor: pointer;
`

export const Container = styled.div`
  width: ${props => (props.width ? props.width : '300px')};
  overflow: ${props => (props.overflow ? props.overflow : 'auto')};
  height: 200px;
  line-height: ${props => (props.height ? props.height : 2)};

  &::-webkit-scrollbar {
    width: 0.5em;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #0000001f;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #0000001f;
  }

  &::-webkit-scrollbar-button {
    display: none;
  }

  &::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`
export const HeaderFlex = styled(Flex)`
  gap: 10px;
  margin-left: 1.5%;
  margin-top: 1.5%;
`
export const UserName = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XL};
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`
export const Dividers = styled(Divider)`
  margin: 0;
`
export const ContentDiv = styled.div`
  width: ${props => (props.width ? props.width : '130%')};
  display: flex;
`
export const VerticalDivider = styled(Divider)`
  height: 100%;
  width: 2px;
  border-top: 18rem solid #e8e8e8;
`

export const MarginLeft = styled.div`
  margin-left: 35px;
`
export const MarginRight = styled.div`
  margin-right: 325px;
`
export const MarginRightSmall = styled.div`
  margin-right: 300px;
`

export const InputDivider = styled(Divider)`
  height: 2rem;
  width: 2px;
`
export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: ${FONT.F_XL};
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`
export const DropDownContent = styled.div`
  font-family: 'Plus Jakarta Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #0a0f2b;
`
export const DropDownOption = styled.div`
  display: flex;
  gap: 10px;
`

export const DropdownButton = styled.button`
  border: none;
  background: unset;
  display: flex;
  gap: 10px;
`
export const RowHeader = styled(Row)`
  margin-top: 20px;
  margin-left: 20px;
`

export const FilterHeading = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
export const FilterOpenClose = styled.div`
  display: flex;
  cursor: pointer;
`
